<nz-button-group *ngIf="listElements.length" [nzSize]="size" #splitButton nz-row>
	<button *ngIf="!isBurgerMenu && firstActiveElement && !firstActiveElement.iconOnly"
		nz-button [nzBlock]="true"
		nzType="{{ firstActiveElement.type }}"
		[ngClass]="{'btnWithAddon': firstActiveElement.icon != null && !noIcon && !iconRight,
				'btnWithAddonRight': firstActiveElement.icon != null && !noIcon && iconRight,
				'blockBtn-Menu': block && listElements.length > 1,
				'blockBtn-noMenu': block && listElements.length <= 1}"
		(click)="elementCallback(firstActiveElement)"
		[disabled]="firstActiveElement.disabled || disabled"
		class="detailStartButton" name="main-button"
		[nzSize]="size"
		[type]="firstActiveElement.buttonType ? firstActiveElement.buttonType : 'button'"
		[attr.form]="firstActiveElement.attrForm"
	>
		<nz-spin nzSimple *ngIf="isSpin"></nz-spin>
		<span class="btnAddon" *ngIf="firstActiveElement.icon && !noIcon && !iconRight" [ngSwitch]="firstActiveElement.iconType">
			<i *ngSwitchCase="'nzicon'" nz-icon [nzType]="firstActiveElement.icon" [nzTheme]="iconTheme" class="btnAddonIcon top-aligned"></i>
			<i-feather *ngSwitchDefault name="{{ firstActiveElement.icon }}" class="btnAddonIcon top-aligned"></i-feather>
		</span>
		{{ (firstActiveElement.shortTitle || firstActiveElement.title) | translate:firstActiveElement.titleParams }}
		<span class="btnAddon" *ngIf="firstActiveElement.icon && !noIcon && iconRight" [ngSwitch]="firstActiveElement.iconType">
			<i *ngSwitchCase="'nzicon'" nz-icon [nzType]="firstActiveElement.icon" [nzTheme]="iconTheme" class="btnAddonIcon top-aligned"></i>
			<i-feather *ngSwitchDefault name="{{ firstActiveElement.icon }}" class="btnAddonIcon top-aligned"></i-feather>
		</span>
	</button>
	<button *ngIf="!isBurgerMenu && firstActiveElement && firstActiveElement.iconOnly"
		nz-button
		nzType="{{ firstActiveElement.type }}"
		nz-tooltip="{{ firstActiveElement.title | translate:firstActiveElement.titleParams }}"
		(click)="elementCallback(firstActiveElement)"
		[disabled]="firstActiveElement.disabled || disabled"
		[nzSize]="size"
		[ngClass]="{'iconButton': size !== 'large', 'largeIconButton': size === 'large'}"
		[type]="firstActiveElement.buttonType ? firstActiveElement.buttonType : 'button'"
		[attr.form]="firstActiveElement.attrForm"
		nz-col
		class="detailStartButton btnIconOnly" name="main-button"
	>
		<span class="btnIcon" [ngSwitch]="firstActiveElement.iconType">
			<i *ngSwitchCase="'nzicon'" nz-icon [nzType]="firstActiveElement.icon" [nzTheme]="iconTheme" class="top-aligned"></i>
			<i-feather *ngSwitchDefault name="{{ firstActiveElement.icon }}" class="top-aligned"></i-feather>
		</span>
	</button>
	<button *ngIf="listElements.length > 1 || isBurgerMenu"
		nz-button
		nzType="default"
		nzPopoverTrigger="click"
		nz-popover
		[nzPopoverContent]="splitButtonList"
		[(nzPopoverVisible)]="isPopoverVisible"
		[nzPopoverPlacement]="['bottomRight']"
		[nzPopoverOverlayClassName]="'popover-no-center-arrow'"
		nz-col
		class="ant-btn-icon-only"
		[disabled]="disabled"
	>
		<i-feather name="menu" class="top-aligned menu-icon"></i-feather>
	</button>
</nz-button-group>

<ng-template #splitButtonList>
	<div [ngStyle]="{'min-width': !isBurgerMenu ? splitButtonElement?.nativeElement?.offsetWidth - 32 + 'px' : '50px'}" name="splitbutton-dropdown">
		<div *ngFor="let element of listElements">
			<nz-divider *ngIf="element.hasDivider" class="popover-divider"></nz-divider>
			<button
				class="popup-entry"
				nz-button
				nzType="text"
				nz-row
				nzBlock
				(click)="elementCallback(element)"
				[disabled]="element.disabled"
				[type]="element.buttonType ? element.buttonType : 'button'"
				[attr.form]="element.attrForm"
			>
				<span class="front-text">
					<ng-container *ngIf="element.icon" [ngSwitch]="element.iconType">
						<i *ngSwitchCase="'nzicon'" nz-icon [nzType]="element.icon" [nzTheme]="iconTheme"></i>
						<i-feather *ngSwitchDefault name="{{ element.icon }}"></i-feather>
					</ng-container>
					<span class="popover-item">{{ element.title | translate:element.titleParams }}</span>
				</span>
			</button>
		</div>
	</div>
</ng-template>
